import { render, staticRenderFns } from "./DesignSettings.vue?vue&type=template&id=98a3c498&scoped=true&"
import script from "./DesignSettings.vue?vue&type=script&lang=js&"
export * from "./DesignSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a3c498",
  null
  
)

export default component.exports